
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component<MenuBar>({})
export default class MenuBar extends Vue {
	@Prop({ type: Array, required: true }) private elements!: Menu[] | MenuGroup[];
	@Prop({ type: String, required: false, default: '' }) private searchText!: string;
	@Prop({ type: Number, required: true, default: 0 }) private currentElementIndex!: number;
	@Watch('elements')
	private onElementsChange(): void {
		this.$nextTick(() => this.updateScrollButtons());
	}

	$refs!: { menuList: HTMLUListElement };

	private showLeftButton: boolean = false;
	private showRightButton: boolean = false;

	private mounted(): void {
		this.updateScrollButtons();
		window.addEventListener('resize', this.updateScrollButtons);
	}

	private beforeDestroy(): void {
		window.removeEventListener('resize', this.updateScrollButtons);
	}

	/**
	 * Toggles scroll buttons visibility based on the menu list's scroll position
	 *
	 * @return {void}
	 * */
	private updateScrollButtons(): void {
		const list = this.$refs.menuList;
		if (!list) {
			return;
		}

		const { scrollLeft, scrollWidth, clientWidth } = list;
		this.showLeftButton = scrollLeft > 0;
		this.showRightButton = scrollLeft + clientWidth < scrollWidth - 1;
	}

	private scrollMenuBar(direction: 'right' | 'left'): void {
		this.$refs.menuList.scrollBy({ left: direction === 'right' ? 250 : -250, behavior: 'smooth' });
	}
}
